var map = {
	"./avatar-user.png": 524,
	"./background-breeding.png": 757,
	"./background-button-done.png": 750,
	"./background-checkin-popup.png": 758,
	"./background-checkin.png": 759,
	"./background-claim-gift.png": 760,
	"./background-create-new-scholarship.png": 554,
	"./background-gift.png": 1053,
	"./background-marketplace.png": 761,
	"./background-new-scholarship.png": 555,
	"./background-popup-gift.png": 1054,
	"./background-popup-redeem.png": 762,
	"./background-profile.png": 377,
	"./background-redeem.png": 763,
	"./background-register.png": 556,
	"./background-view-mobile.png": 751,
	"./background-view.png": 752,
	"./blank-square.png": 764,
	"./breeding-connect-left.png": 765,
	"./breeding-connect-right.png": 766,
	"./breeding-image-disable.png": 1055,
	"./breeding-image.png": 1056,
	"./button-feedback.png": 557,
	"./button-play-now.png": 558,
	"./bybit-text.png": 559,
	"./checkin-hero-left.png": 767,
	"./checkin-hero-right.png": 768,
	"./done-icon.png": 769,
	"./frame-avatar.png": 419,
	"./frame-board.png": 770,
	"./frame-breeding.png": 753,
	"./frame-card-chieftain.png": 420,
	"./frame-card-elder.png": 421,
	"./frame-card-grandchief.png": 422,
	"./frame-card-highchief.png": 423,
	"./frame-card-overseer.png": 424,
	"./frame-card-warchief.png": 425,
	"./frame-card-warlord.png": 426,
	"./frame-card-warmonger.png": 427,
	"./frame-card-warrior.png": 428,
	"./frame-chieftain.png": 771,
	"./frame-dialog.png": 772,
	"./frame-elder.png": 773,
	"./frame-grandchief.png": 774,
	"./frame-hero.png": 749,
	"./frame-highchief.png": 775,
	"./frame-market-hero.png": 429,
	"./frame-overseer.png": 776,
	"./frame-warchief.png": 777,
	"./frame-warlord.png": 778,
	"./frame-warmonger.png": 779,
	"./frame-warrior.png": 780,
	"./free-stamp.png": 1057,
	"./gold-bag-image.png": 781,
	"./gold.png": 754,
	"./hero-card.png": 525,
	"./image-button-explore.png": 526,
	"./info-icon.png": 782,
	"./loading-register.png": 1058,
	"./logo-faded.png": 783,
	"./logo-header.png": 379,
	"./market-cocoon-image.png": 784,
	"./market-hero-image.png": 785,
	"./new-cocoon.png": 786,
	"./no-item-conversation-bubble.png": 1059,
	"./no-item-image.png": 378,
	"./no-item-mobile-bubble.png": 1060,
	"./no-scholarship.png": 560,
	"./pancakeswap-text.png": 561,
	"./refer-steps.png": 1061,
	"./referral-banner-1.png": 562,
	"./rewards-bg.png": 1062,
	"./scholarship-header.png": 563,
	"./tokens-gift.png": 1063,
	"./trapezoid-tag.png": 548,
	"./union.png": 564,
	"./yellow-tripple-arrow.png": 565
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 430;